import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { installPostMessageErrorHandler } from "@/utils/safeFetch";

// Install error handler before React mounts to catch postMessage cloning errors
// from monitoring scripts (like Emergent's debug-monitor.js)
installPostMessageErrorHandler();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
